import { render, staticRenderFns } from "./PFormSelectOrder.vue?vue&type=template&id=6d00f658&scoped=true"
import script from "./PFormSelectOrder.vue?vue&type=script&lang=ts"
export * from "./PFormSelectOrder.vue?vue&type=script&lang=ts"
import style0 from "./PFormSelectOrder.vue?vue&type=style&index=0&id=6d00f658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00f658",
  null
  
)

export default component.exports